import React from 'react';
import { classnames } from '@/utils/classnames/classnames';
import { BadgeProps } from './types';
import useClassNames from './hooks/useClassNames';

// Marketing / status badge shown top-left on product tiles. Distinct from
// the more general-purpose `Tag` atom — this one has fixed product-specific
// variants (clearance, new, on-special) per EWM-187.
const Badge = ({ variant, className = '', children }: React.PropsWithChildren<BadgeProps>) => {
  const { className: badgeClassName } = useClassNames(variant);

  return (
    <span data-testid="badge" className={classnames(badgeClassName, className)}>
      {children}
    </span>
  );
};

export default Badge;
